export default Object.freeze({
    PER_PAGE_OPTIONS: [
        {value: 5, title: '5'},
        {value: 10, title: '10'},
        {value: 15, title: '15'},
        {value: -1, title: '$vuetify.dataFooter.itemsPerPageAll'}
    ],
    ITEMS_PER_PAGE_TEXT: "1ページあたりの行数",
    ITEMS_PER_PAGE_TEXT_WITH_NOTICE: "1ページあたりの行数を入力してください。　※全件表示は0を入力してください。",
  });
  